<template>
    <div class="modal-field">
        <label :for="inputId">{{ label }} <span v-if="required" class="required">*</span></label>
        <slot :error-id="resolvedErrorId" :invalid="Boolean(error)" />
        <!-- Always mounted so a text change inside it is announced; sr-only while empty keeps it
             out of the flex flow, so the column gap below the control is unchanged. -->
        <div :id="resolvedErrorId" class="validation-message" :class="{ 'sr-only': !error }" role="alert">
            <span v-if="error">{{ error }}</span>
        </div>
    </div>
</template>
<script setup lang="ts">
const props = defineProps<{
    label: string;
    inputId?: string;
    error?: string;
    required?: boolean;
    // A control outside this field can need to describe itself with the same message: a
    // duplicate-name check names both halves of the pair, and only one of them holds the
    // message. Naming the id here keeps that second `aria-describedby` writable.
    errorId?: string;
}>();

const generatedErrorId = useId();
const resolvedErrorId = computed(() => props.errorId ?? generatedErrorId);
</script>
<style lang="scss" scoped>
.modal-field {
    @apply flex flex-col items-start gap-1.5 self-stretch;

    label {
        @apply text-zinc-700 text-sm font-medium leading-5;
    }
    .required {
        @apply text-blue-600 ml-0.5;
    }
}
.validation-message {
    // gap-1.5 + mt-0.5 = 8px above the message, the vault modals' validation rhythm
    @apply mt-0.5;

    span {
        @apply text-red-600 text-sm font-normal leading-5;
    }
}
</style>
